import React from 'react';

export default ({ children, titoloSezione }) => (
    <div className="it-list-wrapper list-link-simple">
        {titoloSezione && <h3 className="h6">{titoloSezione}</h3>}
        {children}
    </div>
);



